import React, { useState, useEffect } from 'react';
import './tokenly.css';
import newAbt from './assets/newabt.png';

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      setLoading(true);
      // Replace with your actual API endpoint
      const response = await fetch('https://tokenly.biswaas.com/api/videos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "videoType": ''
        })
      });

      if (!response.ok) {
        throw new Error('Failed to fetch videos');
      }
      
      const data = await response.json();
      
      if (data.status && data.data && data.data.rows) {
        setVideos(data.data.rows);
      } else {
        setError('No videos found');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getYouTubeEmbedUrl = (videoUrl) => {
    // Handle YouTube video URLs and convert to embed format
    if (videoUrl && videoUrl.length === 11) {
      return `https://www.youtube.com/embed/${videoUrl}`;
    }
    // If it's already a full URL, try to extract video ID
    const videoId = videoUrl?.split('v=')[1]?.split('&')[0] || videoUrl?.split('/')[videoUrl?.split('/').length - 1];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : videoUrl;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading videos...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-message">Error: {error}</div>
      </div>
    );
  }

  return (
    <>
      {/* HERO SECTION */}
      <section className="about-hero d-flex align-items-center">
        <div className="about-hero-overlay"></div>
        <div className="container-fluid container-xl px-4 px-md-3">
          <h1 className="display-5 fw-bold text-white mb-1">Video Gallery</h1>
          <p className="text-light mb-0">
            Watch our collection of informative videos about Tokenly
          </p>
        </div>
      </section>

      <div className="videos-container">
        <div className="container-fluid container-xl px-4 px-md-3">
          <div className="videos-grid">
            {videos.map((video) => (
              <div key={video.id} className="video-card">
                <div className="video-thumbnail">
                  <iframe
                    src={getYouTubeEmbedUrl(video.video_url)}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-iframe"
                  />
                </div>
                <div className="video-info">
                  <h3 className="video-title">{video.title}</h3>
                </div>
              </div>
            ))}
          </div>
          
          {videos.length === 0 && !loading && !error && (
            <div className="no-videos">
              <p>No videos available at the moment.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Videos;